<template>
  <div class="v-level --is-level-1 --is-desktop">
    <div class="duplex">
      <div class="row">
        <div class="duplex__left kol-xs-12">
          <Heading title="Fertige Präsente" subtitle="Thematisch perfekt abgestimmt." level="1" />

          <LevelCatalog
            :listItems="$store.getters.getListItemsLevel1Filtered.filter(function(product) {
                const price = getPriceRawForGroup(product, $store.getters.getUserGroupId, !$store.getters.getLevel1Filter.useB2cPrices) + getBoxPriceLvl1(product, $store.getters.getUserGroupId, !$store.getters.getLevel1Filter.useB2cPrices);
                if (
                    price >= $store.getters.getLevel1Filter.priceMin &&
                    price <= $store.getters.getLevel1Filter.priceMax
                ) {
                    return true;
                }
                return false;
            })"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';

import Heading from '@/components/Heading';
import LevelCatalog from '@/components/LevelCatalog';

export default {
  components: {
    Heading,
    LevelCatalog,
  },
  mixins: [logicMixin],
};
</script>

<style lang="scss" scoped>
$component: '--is-level-1';

.#{$component} {
  .duplex__left {
    border-right: 0;
    padding-right: 0.5rem;
  }

  ::v-deep {
    .panel {
      border-top-right-radius: $border-radius;
      border-bottom-right-radius: $border-radius;

      &.--is-catalog {
        margin-right: 0;
      }
    }

    .level-catalog__list {
      margin-left: -3.3%;

      > li {
        min-width: 30%;
        max-width: 30%;
        margin-left: 3.3%;
      }
    }
  }
}
</style>
